module.exports = __webpack_public_path__ + "media/images/flags/16/US-Virgin-Islands-38e345e7cd04a45dfcfef22067a42f30.png";